import Vue from "vue";
import Vuex from "vuex";
import { authen } from "./mudules/authen";
import { logLogin } from "./mudules/logLogin.js";
import { member } from "./mudules/member";
import { permit } from './mudules/permit';
import { utils } from "./mudules/utils";
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    authen,
     utils,
    logLogin,
    member,
    permit,
  },
});

export default store;
